import { Card, Col, Row, Typography, List } from 'antd';
import {
  UsergroupAddOutlined,
  TeamOutlined,
  AppstoreOutlined,
  ShoppingOutlined,
  SettingOutlined,
  DollarOutlined,
  FileTextOutlined,
  LockOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import TokenService from '../../services/token';

export default function SettingPage() {
  const user = TokenService.getUser();

  // Màu nền (Tailwind)
  const colorMap: Record<string, string> = {
    'Cấu hình khách hàng': 'bg-blue-50',
    'Cấu hình sản phẩm': 'bg-amber-50',
    'Cấu hình nghiệp vụ': 'bg-emerald-50',
    'Tài khoản': 'bg-purple-50',
  };

  const groups = [
    {
      title: 'Cấu hình khách hàng',
      icon: <TeamOutlined className="text-blue-500" />,
      items: [
        { title: 'Nguồn khách hàng', icon: <UsergroupAddOutlined />, link: '/settings/sources' },
        { title: 'Nhóm khách hàng', icon: <TeamOutlined />, link: '/settings/types' },
      ],
    },
    {
      title: 'Cấu hình sản phẩm',
      icon: <AppstoreOutlined className="text-amber-500" />,
      items: [
        { title: 'Danh mục sản phẩm', icon: <ShoppingOutlined />, link: '/settings/product-category' },
        { title: 'Danh sách sản phẩm', icon: <FileTextOutlined />, link: '/settings/products' },
      ],
    },
    {
      title: 'Cấu hình nghiệp vụ',
      icon: <SettingOutlined className="text-emerald-500" />,
      items: [
        { title: 'Hạng mục thi công/lắp đặt', icon: <FileTextOutlined />, link: '/settings/work-items' },
        { title: 'Cấu hình chính sách công', icon: <SettingOutlined />, link: '/settings/work-policies' },
        { title: 'Cấu hình phụ phí', icon: <DollarOutlined />, link: '/settings/work-extra-fee' },
        { title: 'Cấu hình thợ/kỹ thuật viên', icon: <DollarOutlined />, link: '/settings/workers' },
      ],
    },
  ];

  const accountSection = {
    title: 'Tài khoản',
    icon: <LockOutlined className="text-purple-500" />,
    items: [{ title: 'Đổi mật khẩu', icon: <LockOutlined />, link: '/settings/change-password' }],
  };

  return (
    <div className="p-8">
      <Typography.Title level={2} className="text-center mb-8">
        Thiết lập cấu hình
      </Typography.Title>

      <Row gutter={[16, 16]}>
        {user.role === 1 &&
          groups.map(group => (
            <Col key={group.title} md={12} sm={24} xs={24}>
              <Card
                className={`${colorMap[group.title]} rounded-2xl shadow-sm`}
                styles={{
                  body: {
                    paddingTop: 12,
                    paddingBottom: 12,
                  },
                }}
                title={
                  <div className="flex items-center gap-2 text-lg font-semibold">
                    {group.icon}
                    <span className="text-gray-700">{group.title}</span>
                  </div>
                }
                bordered
              >
                <List
                  itemLayout="horizontal"
                  dataSource={group.items}
                  renderItem={item => (
                    <List.Item className="hover:bg-white/60 transition">
                      <Link to={item.link} className="flex items-center gap-2 w-full text-base text-gray-700 px-2">
                        {item.icon}
                        <span>{item.title}</span>
                      </Link>
                    </List.Item>
                  )}
                />
              </Card>
            </Col>
          ))}

        {/* Section: Account */}
        <Col md={12} sm={24} xs={24}>
          <Card
            className={`${colorMap[accountSection.title]} rounded-2xl shadow-sm`}
            styles={{
              body: {
                paddingTop: 12,
                paddingBottom: 12,
              },
            }}
            title={
              <div className="flex items-center gap-2 text-lg font-semibold">
                {accountSection.icon}
                <span className="text-gray-700">{accountSection.title}</span>
              </div>
            }
            bordered
          >
            <List
              itemLayout="horizontal"
              dataSource={accountSection.items}
              renderItem={item => (
                <List.Item className="hover:bg-white/60 transition ">
                  <Link to={item.link} className="flex items-center gap-2 w-full text-base text-gray-700 px-2">
                    {item.icon}
                    <span>{item.title}</span>
                  </Link>
                </List.Item>
              )}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
